const queryString = require('query-string')
const in_array = require('in_array')
const generalEvents = require('../events/general-events')
const GlobalAlerts = require('global_alerts')
const Lang = require('lang');

function Products() {
  nifty.body.overlay({fixed: true})
  const modal = $('#modal-produto')
  const modalContent = modal.find('.modal-content')
  const url = function(id) {
    return route('app.settings.financeiro.produto', {idCompanyPlanProduct: id})
  }

  const openBill = function(id) {
    nifty.body.overlay('show')

    $.get(url(id))
      .done(function(html) {
        modalContent.html(html);
        modal.modal('show')
        generalEvents()
      })
      .fail(function(error) {
        if(error.status === 404) {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.product_not_found'),
            message: Lang.get('js/src/functions/Bills.product_doesnt_exist'),
            type: 'danger',
            timer: 10000
          })
        } else if(error.status === 401) {
          location.reload();
        } else {
          GlobalAlerts.createAndShow({
            title: Lang.get('js/src/functions/Bills.ops'),
            message: Lang.get('js/src/functions/Bills.unexpected_error'),
            type: 'danger',
            timer: 10000
          })
        }
      })
      .always(function() {
        nifty.body.overlay('hide')
      })
  }

  $('body').on('click', '[data-produto]', function(e) {
    const id = this.dataset.produto
    const tagName = e.target.tagName.toLowerCase()

    if(in_array(tagName, ['a', 'button'])) {
      return true
    }

    openBill(id)
  })
}

exports.init = Products
